module.exports = __webpack_public_path__ + "static/media/anage-select-home-img.e3351aa5.webp";